// extracted by mini-css-extract-plugin
module.exports = {"left":"filter-background_left__vyrJx","right":"filter-background_right__3vtf5"};